export const INTEGRATIONS_SET = "INTEGRATIONS_SET";
export const INTEGRATIONS_DELETE_SUCCESS = "INTEGRATIONS_DELETE_SUCCESS";
export const INTEGRATION_TOGGLE = "INTEGRATION_TOGGLE";
export const INTEGRATION_SET_MAPPING = "INTEGRATION_SET_MAPPING";
